<template>
    <div class="container_food_list">
        <section class="food_list food_seccion" v-for="(i, idx) in listMain" :key="idx" :id="'section-'+i.id" :data-row="i.id">
            <edit-category-name :indicador="i.id" :cat="i"></edit-category-name>
            <draggable v-model="i.foods" tag="div" v-bind="dragOptions" @change="checkMove(i.foods)" @start="isDragging = true" @end="isDragging = false" handle=".handle">
                <article class="food_item_container" v-for="(f, index) in i.foods" :key="index" :data-indicador="i.id">
                    <div class="handle"><i class="fas fa-arrows-alt-v"></i></div>
                    <div class="food_item" :data-indicador="i.id">
                        <header class="food_item_header" :data-indicador="i.id">
                            <edit-food-name :indicador="i.id" :food="f"></edit-food-name>
                            <!-- <h4 class="food_item_name" :data-indicador="i.id">{{f.name_food}}</h4> -->
                            <slider-media :indicador="i.id" :gallery="f.gallery" :urlMedia="urlMedia" @editGallery="$emit('clickAction', $event)" :foodItem="f"></slider-media>
                            <button class="btn btn-danger btnDelFood" title="Delete Food"  @click="$emit('delFood', f)"><i class="fas fa-trash"></i></button>
                        </header>
                        <edit-food-details :indicador="i.id" :food="f"></edit-food-details>
                        <edit-food-price :indicador="i.id" :food="f"></edit-food-price>
                    </div>
                </article>
            </draggable>
            <div class="add_food_new text-center">
                <button class="btn btn-primary btn-xs" @click.prevent="addFood(i)" :disabled="loadSave"><i class="fas fa-chevron-up"></i> Add New Food</button>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from 'vuedraggable'
import foodCategory from "./foodCategory.vue"
import foodEditName from "./foodEditName.vue"
import foodEditPrice from "./foodEditPrice.vue"
import foodEditDescription from "./foodEditDescription.vue"
import foodSlider from "./foodSlider.vue"
export default {
    props: ['urlMedia'],
    components: {
        draggable,
        'edit-category-name': foodCategory,
        'edit-food-name': foodEditName,
        'edit-food-price': foodEditPrice,
        'edit-food-details': foodEditDescription,
        'slider-media': foodSlider,
    },
    data(){
        return {
            apis: null,
            coordenadas: null,
            currentCoord: null,
            scrollingValue: 0,
            coordIndex: 0,
            listMain: [],
            playVideo: false,
            loadSave: false,
            details: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia provident eum iusto! Eveniet, reprehenderit quod. Eaque unde fuga dicta necessitatibus! Corrupti odio tempore totam ratione nulla eius velit provident porro',
        };
    },
    created() {
        let t = this;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bMenu;
        t.listMain = t.$store.getters['ModApps/Marketea/get_bmenu_listCat'];
    },
    beforeDestroy() {
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            getListCat: "get_bmenu_listCat",
            getCatActive: "get_bmenu_catActive",
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "gallery",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    watch: {
        getListCat: function(newVal, oldVal){
            let t = this;
            t.updateList(newVal);
        },
    },
    mounted(){
        let t = this;
        if(document.querySelector('.container_food_list')){
            if(document.querySelectorAll('.food_seccion').length>0){
                t.startEvents();
            }
        }
    },
    methods: {
        callbackScrolling(scrollTop){
            let t = this;
            let changeSection = false;
            let direction = 0;
            if(t.coordenadas.length>2){
                if(scrollTop==0){
                    console.log('scrollTop initial', scrollTop)
                    console.log('currentCoord', t.coordenadas[t.coordIndex])
                    let categoryActive = t.listMain.find(i => { return (i.id == t.currentCoord.id)});
                    let payload = {key: 'bmenu_catActive', val: categoryActive}
                    t.$store.commit('ModApps/Marketea/set_bMenuValStorage', payload);
                    setTimeout(() => { t.$emit('followItem');}, 100);
                    t.$emit('sectionActive', t.currentCoord.elemtId)
                }else{
                    if(t.scrollingValue < scrollTop){
                        changeSection=(scrollTop> t.currentCoord.height); // -(t.currentCoord.top+300)
                        direction=1;
                    }else{
                        // changeSection=t.coordenadas.find(i => { return (scrollTop <= i.height && i.height <= t.currentCoord.height)})
                        changeSection=(scrollTop < t.currentCoord.height);
                        direction=-1;
                    }
                    t.scrollingValue=scrollTop;
                    if(changeSection){
                        if(direction>0){
                            t.coordIndex++;
                            console.log('scrollTop ++', scrollTop, t.currentCoord.bottom); // bajando
                        }else if(direction<0){
                            t.coordIndex--;
                            console.log('scrollTop --', scrollTop, t.currentCoord.top);// subiendo
                        }else{t.coordIndex=0;}
                        if(t.coordIndex<0){t.coordIndex=0;}
                        if(t.coordenadas[t.coordIndex].height !=t.currentCoord.height){
                            console.log('section activa', t.coordenadas[t.coordIndex].elemtId)
                            console.log('currentCoord', t.coordenadas[t.coordIndex])
                            t.currentCoord = t.coordenadas[t.coordIndex];
                            changeSection=false;
                            let categoryActive = t.listMain.find(i => { return (i.id == t.currentCoord.id)});
                            let payload = {key: 'bmenu_catActive', val: categoryActive}
                            t.$store.commit('ModApps/Marketea/set_bMenuValStorage', payload);
                            setTimeout(() => {
                                t.$emit('followItem')
                            }, 100);
                            t.$emit('sectionActive', t.currentCoord.elemtId)
                        }
                    }
                }
            }
        },
        sectActive(idx){
            let t = this;
            if(t.getCatActive.id!=idx){
                let categoryActive = t.listMain.find(i => { return (i.id == idx)});
                if(categoryActive){
                    // console.log('change section', idx);
                    t.$emit('sectionActive', 'section-'+idx)
                    let payload = {key: 'bmenu_catActive', val: categoryActive}
                    t.$store.commit('ModApps/Marketea/set_bMenuValStorage', payload);
                    setTimeout(() => {
                        t.$emit('followItem')
                    }, 100);
                }
            }
        },
        async updateList(list){
            let t = this;
            t.listMain = list;
            await this.sleep(800);
            t.startEvents();
        },
        async startEvents(){
            let t= this;
            t.resetEvent();
            await this.sleep(1000);
            console.log('startEvents')
            const food_list = document.querySelector('.container_food_list');
            const secciones = document.querySelectorAll('.food_seccion');
            t.coordenadas = [];
            let cont = 0;
            let contBottom = 0;
            // console.log('secciones', secciones);
            secciones.forEach(section => {
                let rect= section.getBoundingClientRect();
                let setItem = {height: (cont + section.offsetHeight), elemtId: section.id, top: rect.top, bottom: (rect.bottom + rect.top), id: section.getAttribute('data-row')}
                t.coordenadas.push(setItem);
                cont += section.offsetHeight
                contBottom+= rect.bottom;
                let sSelectores =document.querySelectorAll('[data-indicador="'+section.getAttribute('data-row')+'"]');
                if(sSelectores.length>0){
                    sSelectores.forEach(s => {
                        s.addEventListener('mouseover', (e) => {
                            let idx = e.target.getAttribute('data-indicador');
                            t.sectActive(idx)
                        });
                        s.addEventListener('touchstart', (e) => {
                            let idx = e.target.getAttribute('data-indicador');
                            t.sectActive(idx)
                        });
                        s.addEventListener('click', (e) => {
                            let idx = e.target.getAttribute('data-indicador');
                            t.sectActive(idx)
                        });
                    })
                }
                // console.log(setItem.id, setItem.bottom);
                // console.log('contBottom', contBottom)
            });
            // console.log('coordenadas', t.coordenadas);
            // console.log('getCatActive', t.getCatActive);
            t.currentCoord=t.coordenadas.find(r => {return r.id==t.getCatActive.id})
            // console.log('currentCoord', t.currentCoord);
            // t.callbackScrolling(0);
            food_list.addEventListener('scroll', (e) => {
                // console.log('scrollTop target', e.target.scrollTop)
                // t.callbackScrolling(e.target.scrollTop);
                // t.handleVideoPlayback()
            });
            // t.handleVideoPlayback();
            const itemVideos = document.querySelectorAll('.food_item_video');
            itemVideos.forEach(iVideo => {
                iVideo.addEventListener('click', (e) => {
                    console.log('click gallery', e.target.scrollLeft)
                    t.playPauseVideo(e.target)
                });
                iVideo.addEventListener('touchstart', (e) => {
                    console.log('touchstart gallery', e.target.scrollLeft)
                    t.playPauseVideo(e.target)
                });
            });
        },
        resetEvent(){
            console.log('resetEvent')
            const food_list = document.querySelector('.container_food_list');
            food_list.removeEventListener('scroll', (e) => {
                console.log('scrollTop target', e.target)
            }, true);
            const secciones = document.querySelectorAll('.food_seccion');
            secciones.forEach(section => {
                let sSelectores =document.querySelectorAll('[data-indicador="'+section.getAttribute('data-row')+'"]');
                if(sSelectores.length>0){
                    sSelectores.forEach(s => {
                        s.removeEventListener('mouseover', (e) => {
                            let idx = e.target.getAttribute('data-indicador');
                        }, true);
                        s.removeEventListener('touchstart', (e) => {
                            let idx = e.target.getAttribute('data-indicador');
                        }, true);
                        s.removeEventListener('click', (e) => {
                            let idx = e.target.getAttribute('data-indicador');
                        }, true);
                    })
                }
            });
            const itemVideos = document.querySelectorAll('.food_item_video');
            itemVideos.forEach(iVideo => {
                iVideo.removeEventListener('click', (e) => {
                    console.log('click gallery', e.target)
                }, true);
                iVideo.removeEventListener('touchstart', (e) => {
                    console.log('touchstart gallery', e.target)
                }, true);
            });
        },
        ellipsisJS (textString, lengthMax) {
            let a= textString.split(' '); // texto como array
            let s =''; // resultado
            let n=0;// contador
            while(s.length < lengthMax) {
                s+=''+a[n]; n++;
                // console.log(s)
            }
            return s.replace(/\W*\s(\S)*$/, '...');
        },
        isElementInViewport(el) {
            let t = this;
            return new Promise(resolve => {
                const rect = el.getBoundingClientRect();
                let result= t.sleep(2000).then(r => {
                    console.log(`Waiting 2 seconds...`);
                    return (
                        rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                    );
                });
                resolve(result);
            });
        },
        // Función para reproducir o detener el video según su visibilidad
        handleVideoPlayback() {
            let t = this;
            const videos = document.querySelectorAll('.food_item_video');
            videos.forEach((video) => {
                // console.log('video', video);
                t.playPauseVideo(video)
            });
        },
        playPauseVideo(video){
            let t = this;
            // Verifica si el video está en el viewport
            t.playVideo = !t.playVideo;
            t.isElementInViewport(video).then(r => {
                if (r) {
                    // console.log('video.paused', video.paused)
                    // console.log('video.playing', video.playing)
                    // console.log('video.playsInline', video.playsInline)
                    if (video.paused && t.playVideo) {
                        console.log('play');
                        video.play(); // solo funciona si el video esta en muted
                    }
                } else {
                    if (!video.paused) {
                        console.log('pause');
                        video.pause();
                    }
                }
            });
        },
        sleep(ms) {
            console.log('sleep', ms);
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        addFood(i){
            let t= this;
            let urlService = t.apis.set(3)// setFood
            if(!t.loadSave){
                t.loadSave = true;
                // @ts-ignore
                window.master.post(urlService, {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    pusher_id: pusher.connection.socket_id,
                    cat_id: i.id,
                    name_food: 'Food name',
                    desc_food: t.details,
                    price: '0',
                })
                .then((response) => {
                    console.log(urlService, response.data);
                    t.loadSave = false;
                    if(response.data.status && response.data.get){
                        t.$store.commit('ModApps/Marketea/set_bMenuAddFood', response.data.get);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    t.loadSave = false;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error",
                        text: "Could not be save!",
                    });
                });
            }
        },
        checkMove(foods) {
            let t = this;
            foods.map((item, index) => {
                item.orden = index;
            });
            console.log('move foods', foods)
            let urlService = t.apis.set(4)// setFoodOrden
            window.master.post(urlService, {
                ordenFoods: foods,
            })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: "Error",
                    text: "Could not be saved!",
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
